import SystemNotification from "../models/system-notification";
import { getList } from "./generics";

const NOTIFICATIONS_LIMIT = 20;

// The tax payer is resolved from the X-Tax-Payer-ID header injected by
// fetchAuthenticated, so no extra parameter is needed here.
export const getSystemNotifications = () =>
  getList<SystemNotification>("/system_notifications/", NOTIFICATIONS_LIMIT, 0);
